import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const userString = localStorage.getItem("User");
  const user = userString ? JSON.parse(userString) : null;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}